import styled, { css } from "styled-components";

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	gap: 0.8rem;
	width: 100%;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex-direction: column;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopLarge}) {
		gap: 0.35rem;
	}
`;

export const AreaQuotesStatus = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 0.796rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
	}
`;
interface IAreaCollumnLabelStatusProps {
	$isDelayed?: boolean;
}

export const AreaCollumnLabelStatus = styled.div<IAreaCollumnLabelStatusProps>`
	${({ $isDelayed, theme }) =>
		$isDelayed &&
		css`
			color: ${theme.red};
		`}
`;
